/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useEffect, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import UsageTracker from '../../../utils/UsageTracker';
import { formatSecondsToTextDuration } from '../../../utils/utils';
import { useExamDeadline, useMostRecentExamAttempt } from '../examsQueries';
import { useExpiredModalState } from '../examsStores';
import { useValidateExam } from '../examsQueries';
import { useFullTrack } from '../../tracks';
import { MS_IN_A_MINUTE } from '../../../constants/TimeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_SECOND_IN_MS = 1000;
const ExamTimer = ({
  trackId,
  passive,
  language,
  clientStartTime
}) => {
  var _track$exam;
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  const {
    examDeadline,
    examDeadlineLoading
  } = useExamDeadline(Number(trackId), language);
  const {
    track
  } = useFullTrack(trackId, language);
  const localDeadline = clientStartTime ? clientStartTime + ((track === null || track === void 0 || (_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.durationMinutes) || 0) * MS_IN_A_MINUTE : null;
  const timerDeadline = localDeadline || examDeadline || 0;
  const [remainingSeconds, setRemainingSeconds] = useState((timerDeadline - Date.now()) / ONE_SECOND_IN_MS);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const [validateExam] = useValidateExam(Number(trackId), language);
  const handleTimeExpired = useCallback(() => {
    if (mostRecentExamAttempt && !mostRecentExamAttempt.finished && !passive) {
      UsageTracker.track('examInteraction', {
        action: 'time-expired',
        trigger: 'timeout',
        examId: track && track.exam.id,
        examLength: mostRecentExamAttempt.questions.length,
        trackId: trackId && trackId.toString(),
        trackName: track && track.name,
        examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
      });
      setShowExpiredModal(true);
      return validateExam(mostRecentExamAttempt.id).then(() => {
        UsageTracker.track('examInteraction', {
          action: 'completed',
          examId: track && track.exam.id,
          examLength: mostRecentExamAttempt.questions.length,
          trackId: trackId && trackId.toString(),
          trackName: track && track.name,
          examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
        });
      });
    }
    return null;
  }, [mostRecentExamAttempt, passive, setShowExpiredModal, track, trackId, validateExam]);
  useEffect(() => {
    if (showExpiredModal || examDeadline === null) {
      return () => {};
    }
    const interval = setInterval(() => {
      const secondsLeft = (timerDeadline - Date.now()) / ONE_SECOND_IN_MS;
      if (secondsLeft <= 0) {
        clearInterval(interval);
        handleTimeExpired();
      } else {
        setRemainingSeconds(secondsLeft);
      }
    }, ONE_SECOND_IN_MS);
    return () => {
      clearInterval(interval);
    };
  }, [examDeadline, showExpiredModal, handleTimeExpired, timerDeadline]);
  if (examDeadlineLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.examQuestion.timeRemaining",
      options: {
        timeRemaining: formatSecondsToTextDuration(remainingSeconds)
      }
    })
  });
};
export default ExamTimer;